<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Box</ng-container>
  <ng-container *ngIf="data.id">Edit Box</ng-container>
</h1>
<mat-dialog-content>

  <aw-box-form [box]="data" (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-box-form>

</mat-dialog-content>